import React, {useCallback, useEffect, useMemo, useState} from "react"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import {Box, Grid, Paper, Typography} from "@mui/material"
import {ReactComponent as PlusSquareIcon} from "src/v2/assets/icons/plus-square-icon.svg"
import {useNavigate} from "react-router-dom"
import {MOTOR_EVENTOS_CADASTRO_PAGE, MOTOR_EVENTOS_PARAMETROS} from "src/utils/routes"
import {dispatchSnackbar} from "../../../components/SnackBar/snackbar-bus"
import ButtonWithIcon from "../../../components/Button/Button"
import DataGridTable from "../../../components/Table/data-grid-table"
import DuplicarModal from "../components/DuplicarModal/duplicar-modal"
import OcrPromptComponent from "../components/OCR/ocr-prompt-component"
import OcrTableComponent from "../components/OCR/ocr-table-component"
import CetipVersaoEventosFilterComponent from "../components/CetipVersaoFilter/cetip-versao-eventos-filter-component"
import {createColumnsCadastroEventosMotor} from "./cadastro-motor-eventos-const"
import MotorParametrosService from "../../../../services/motor-parametros-service"
import MotorService from "src/services/motor-service"
import DuplicarModalEventos from "./componentes/duplicar-modal-eventos"
import {MotorDuplicarEventosService} from "../../../../services/motor-duplicar-eventos-service"
import EventosService from "../../../../services/eventos_service"

const TITLE_MOTOR_EVENTOS_LIST_PAGE = "Cadastro de Eventos"
const OCR_SOURCE = "parametros"

const MotorCadastroEventosListPage = () => {
    const [cetip, setCetip] = useState("")
    const [versaoDocumento, setVersaoDocumento] = useState("")
    const [loadingTable, setLoadingTable] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)
    const [rows, setRows] = useState([])

    const pagination = {page: 0}
    const navigate = useNavigate()
    const motorService = new MotorService()
    const service = useMemo(() => new MotorParametrosService(), [])
    const eventosService = useMemo(() => new EventosService(), [])
    const duplicarService = useMemo(() => new MotorDuplicarEventosService(), [])
    const [modalDuplicarOpen, setModalDuplicarOpen] = useState(false)
    const [linhaSelecionada, setLinhaSelecionada] = useState(null)

    useEffect(() => {
        loadCadastros(cetip, versaoDocumento)
    }, [])

    const handleDuplicarCadastro = useCallback((row) => {
        setLinhaSelecionada(row)
        setModalDuplicarOpen(true)
    }, [])

    const loadCadastros = (cetip, versao) => {
        setLoadingTable(true)
        eventosService.getEventos(cetip, versao, null)
            .then((response) => {
                const {body: {Cadastros}} = response
                const list = Cadastros.map((obj, index) => ({...obj, id: index}))
                setRows(list)
            })
            .catch(() => {
                dispatchSnackbar("Erro ao carregar os registros!", "error")
            })
            .finally(() => {
                setLoadingTable(false)
            })
    }

    const loadFilterCadastros = (cetip, versao) => {
        setLoadingTable(true)
        eventosService.getEventos(cetip, versao, null)
            .then((response) => {
                const {body: {Cadastros}} = response
                const filteredCadastros = Cadastros.filter((item) => item.Status !== "Não Iniciado")
                const list = filteredCadastros.map((obj, index) => ({...obj, id: index}))
                setRows(list)
            })
            .catch((err) => {
                console.log(err)
                dispatchSnackbar(err.message, "error")
            })
            .finally(() => {
                setLoadingTable(false)
            })
    }

    const iniciaNovoFluxo = async () => {  // Criar Fluxo Ordinario
        if (!cetip || !versaoDocumento) {
            dispatchSnackbar("Informe CETIP e Versão Documento", "warning")
            return
        }
        setLoadingPage(true)
        try {
            const responseCaracteristica = await motorService.loadCadastros(cetip, versaoDocumento)
            const lista = responseCaracteristica?.body ?? []
            const caracteristica = lista.find(
                (c) => String(c.VersaoDocumento) === String(versaoDocumento)
            )

            if (!caracteristica?.ID) {
                dispatchSnackbar("Não existe cadastro em produção para este CETIP e Versão.", "warning")
                return
            }

            const {ID, CETIP, VersaoDocumento} = caracteristica
            const cadastroResponse = await motorService.getCadastro(ID)
            const cadastroDetail = cadastroResponse?.body ?? null

            eventosService.getEventos(null, null, ID)
                .then((response) => {
                    const {body: {Cadastros}} = response
                    if (Cadastros !== null || Cadastros.length > 0) {
                        const cadastro = Cadastros[0]
                        const {Status} = cadastro

                        if(Status !== "Não Iniciado") {
                            dispatchSnackbar("Já existe um cadastro iniciado para o CETIP + Versão Documento.", "warning")
                            return
                        }
                        let {Caracteristica} = cadastroDetail
                        Caracteristica.CETIP = CETIP
                        Caracteristica.VersaoDocumento = versaoDocumento
                        return navigate(MOTOR_EVENTOS_CADASTRO_PAGE, {
                            state: {
                                RendaFixaCaracteristicasID: ID,
                                CETIP: CETIP,
                                VersaoDocumento: VersaoDocumento,
                                Data: Caracteristica,
                                Status: Status,
                                origem: "novo"
                            }
                        })
                    }
                    dispatchSnackbar("Não foi encontrado nenhum cadasto para  o CETIP + Versão Documento.", "warning")
                })
                .catch((err) => {
                    console.log(err)
                    dispatchSnackbar("Erro ao carregar cadastros.", "error")
                })
                .finally(() => {
                    setLoadingPage(false)
                })
        } catch (error) {
            dispatchSnackbar("Erro ao validar cadastro.", "error")
            setLoadingPage(false)
        }
    }

    const handleVerCadastro = useCallback(
        async (row) => {
            try {
                const {CETIP, VersaoDocumento, RendaFixaCaracteristicasID, Status, Parametros} = row

                if (!CETIP) {
                    dispatchSnackbar("CETIP inválido para visualização", "warning")
                    return
                }

                setLoadingPage(true)

                navigate(MOTOR_EVENTOS_CADASTRO_PAGE, {
                    state: {
                        RendaFixaCaracteristicasID: RendaFixaCaracteristicasID,
                        Status: Status,
                        CETIP: CETIP,
                        VersaoDocumento: VersaoDocumento,
                        Parametros: Parametros,
                        Data: row,
                        origem: "ver"
                    }
                })
            } catch (error) {
                console.log(error)
                dispatchSnackbar("Erro ao carregar cadastro.", "error")
            } finally {
                setLoadingPage(false)
            }
        },
        [navigate, motorService, service]
    )

    const columns = useMemo(
        () => createColumnsCadastroEventosMotor(handleVerCadastro, handleDuplicarCadastro),
        [handleVerCadastro, handleDuplicarCadastro]
    )

    const recuperaDadosDuplicacao = async (cetip, versao, rendaFixaCaracteristicasID, cadastroDestinoId) => {
        try {
            setLoadingPage(true)
            const dadosDuplicados = await duplicarService.duplicaCadastroEventos(cetip, versao, rendaFixaCaracteristicasID, cadastroDestinoId)
            navigate(MOTOR_EVENTOS_PARAMETROS, {
                state: {
                    data: dadosDuplicados,
                    origem: "duplicar"
                }
            })
        } catch (error) {
            console.log(error)
        } finally {
            setLoadingPage(false)
        }
    }

    const buscarCadastroDestino = async (novoCetip, novaVersao) => {  // Confirmar duplicação
        const response = await motorService.loadCadastros(novoCetip, novaVersao)
        return response?.body || []
    }

    const existeCadastroParametros = async (cadastroId) => {
        const results = await Promise.allSettled([
            service.getCadastroParametros(cadastroId),
            service.getCadastroTemporarioParametros(cadastroId)
        ])
        const [parametrosProducaoRes, parametrosTemporarioRes] = results
        const parametrosProducao = parametrosProducaoRes.status === 'fulfilled' ? parametrosProducaoRes.value : null
        const parametrosTemporario = parametrosTemporarioRes.status === 'fulfilled' ? parametrosTemporarioRes.value : null

        return parametrosProducao !== null || parametrosTemporario !== null
    }

    const handleConfirmarDuplicacao = async (dadosDoModal) => {
        setLoadingPage(true)

        try {
            const {novoCetip, novaVersao, original: {RendaFixaCaracteristicasID}} = dadosDoModal
            const cadastros = await buscarCadastroDestino(novoCetip, novaVersao)

            if (cadastros.length === 0) {
                dispatchSnackbar("Cadastro não encontrado para o CETIP + Versão Documento informados.", "warning")
                return
            }

            const cadastroDestinoId = cadastros[0].ID
            const cadastroParametros = await existeCadastroParametros(cadastroDestinoId)
            if (cadastroParametros) {
                dispatchSnackbar("Já existe um cadastro para CETIP + Versão Documento informados.", "warning")
                setLoadingPage(false)
                return
            }
            recuperaDadosDuplicacao(novoCetip, novaVersao, RendaFixaCaracteristicasID, cadastroDestinoId)
        } catch (error) {
            console.error("Erro ao duplicar os registros: ", error)
            dispatchSnackbar("Houve um erro ao tentar duplicar os registros.", "error")
            setLoadingPage(false)
        }
    }

    return (
        <SideBarLayout
            title={TITLE_MOTOR_EVENTOS_LIST_PAGE}
            header
            loading={loadingPage}
            headerTitle={TITLE_MOTOR_EVENTOS_LIST_PAGE}
            headerImage={"/background/eventos_headers.jpg"}
            headerPosition={"1% 41%"}
        >
            <Box sx={{mt: -2}}>
                <CetipVersaoEventosFilterComponent
                    setCetip={setCetip}
                    setVersao={setVersaoDocumento}
                    returnCetipVersao={(cetipReturned, versaoReturned) => {
                        setRows([])
                        loadFilterCadastros(cetipReturned, versaoReturned)
                        setCetip(cetipReturned)
                        setVersaoDocumento(versaoReturned)
                    }}
                    clearFilter={() => {
                        setCetip("")
                        setVersaoDocumento("")
                        loadCadastros(null, null)
                    }}
                />
                <br/>

                {/* Container para inicio do cadastro */}
                <Grid container spacing={3} direction="row">
                    {/* Item do leitor de OCR */}
                    <Grid item xs={12} md={8}>
                        <OcrPromptComponent
                            source={OCR_SOURCE}
                            cetip={cetip}
                            callback={() => {
                            }}
                            versaoDocumento={versaoDocumento}
                            loading={setLoadingPage}/>
                    </Grid>

                    {/* Item do cadastro manual */}
                    <Grid item xs={12} md={4}>
                        <Paper sx={{p: 3, height: '100%', borderRadius: 0}}>
                            <Grid container direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <Grid item sx={{mb: 12}}>
                                    <Typography variant="body1" component="span" color="common.white">
                                        CADASTRO MANUAL
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <ButtonWithIcon
                                        icon={<PlusSquareIcon sx={{fontSize: 18}}/>}
                                        onClick={iniciaNovoFluxo}>
                                        CRIAR FLUXO ORDINARIO
                                    </ButtonWithIcon>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                <br/>

                {/* Lista de cadastros OCR */}
                <OcrTableComponent
                    source={OCR_SOURCE}
                    paginaCadastroOCR={MOTOR_EVENTOS_PARAMETROS}
                />
                <br/>

                {/* Lista de cadastros */}
                <Grid item xs={12} md={4}>
                    <Paper sx={{p: 3, borderRadius: 0}}>
                        <Box
                            sx={{
                                flex: 1,
                                overflowX: "auto",
                                width: "100%",
                                display: "block",
                            }}
                        >
                            <DataGridTable
                                columns={columns}
                                rows={rows}
                                pagination={pagination}
                                disableDeleteColumn
                                loading={loadingTable}
                                resetKey={`cadastro-motor`}
                            />
                        </Box>
                    </Paper>
                </Grid>
            </Box>
            <DuplicarModalEventos
                open={false}/>

            <DuplicarModal
                autoComplete
                open={modalDuplicarOpen}
                onClose={() => setModalDuplicarOpen(false)}
                rowOriginal={linhaSelecionada}
                onConfirm={async (data) => await handleConfirmarDuplicacao(data)}
            />
        </SideBarLayout>
    )
}

export default MotorCadastroEventosListPage
